/**
* Twitter Feed JS
* -----------------------------------------------------------------------------
*
* All the JS for the Twitter Feed component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'twitter-feed',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );


      $( 'EappsTwitterFeed' ).ready( ( ) => {
        setTimeout( () => {
          $( '.eapps-twitter-feed-header-user-image' ).attr( 'aria-label', 'KHI logo' );
        }, '1000' );
      } );

      // $( document ).on( 'click', ( event ) => {
      //   if ( $( event.target ).hasClass( 'eapps-twitter-feed-posts-show-more' ) ) {
      //     setTimeout( () => {
      //       $( '.eapps-twitter-feed-header-user-image' ).attr( 'aria-label', 'KHI logo' );
      //     }, '2000' );
      //   }
      // } );
    },
    finalize: function() {

    },
  };

  // Hooks the component into the app
  app.registerComponent( 'twitter-feed', COMPONENT );
} )( app );
